<template>
  <div>
    <div class="col-xs-12 noPadding slideMenu">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="row otherWrap">
      <div style="width:80%;margin:0PX auto;">
        <h1 style="text-align: center;margin:20px 0;font-size: 18px;font-weight: bold;}">主要职责</h1>
        <div style="font-size: 13px;
    line-height: 2em;"> <p style="margin:13px 0">1.贯彻落实上级部门有关会展工作的方针政策和工作部署，协助行业管理部门研究制定全市会展业的发展规划和相关政策，协助做好全市会展业发展战略研究和会展人才培育工作，促进我市会展业的发展；</p>
        <p style="margin:13px 0">2.接受商务部、国台办、福建省政府的业务指导，负责做好投洽会政府性事务筹备工作，并协助做好海峡论坛各项事务性、技术性、辅助性工作；</p>
        <p style="margin:13px 0">3.负责做好投洽会、海峡论坛各相关单位的联络和协调工作；</p>
        <p style="margin:13px 0">4.负责做好投洽会重大活动、客商邀请、论坛研讨、宣传推介等筹备工作；负责投洽会、国际投资论坛、海峡论坛的经费预（决）算和日常收支核算等财务管理工作；</p>
        <p style="margin:13px 0">5.开展国际投资促进和对台经贸交流活动，开展与国际投资促进相关的业务和人才培训工作。</p>
      </div>
       
      </div>
    </div>
  </div>
</template>

<script>
import subMenuBar from "@/components/subMenuBar/subMenuBar";
import VClamp from "vue-clamp";
export default {
  components: {
    subMenuBar,
    VClamp
  },
  data() {
    return {
      pcSubPageMenu: this.globalmenu.project,
     
    };
  },
  methods: {
   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
@import "../../static/function.less";
.otherWrap {
  margin-bottom: 4%;
  .page-header-news {
    margin-top: 3%;
  }
  .page-swiper {
    padding-top: 15px;
    .swiper-slide {
      text-align: center;
      .newss-title {
        position: absolute;
        bottom: 0px;
        background: rgba(0, 0, 0, 0.7);
        left: 0;
        right: 0;
        padding: 2% 3%;
        color: #fff;
        text-align: left;
        h4 {
          line-height: 24px;
          font-size: @font16;
        }
        p {
          font-size: @font14;
          margin: 1% 0px 3% 0px;
        }
      }
    }
  }
  .newsPagination {
    bottom: 0px;
  }
  .page-wrap {
    padding-top: 2%;
    .page-other {
      margin-top: 1%;
      cursor: pointer;
      &:hover {
        p {
          .hoverTxtColor();
        }
      }
      &:before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 3px;
        background-color: #f00;
        vertical-align: top;
        margin-top: 8px;
        margin-right: 6px;
        border-radius: 50%;
      }
      p {
        display: inline-block;
        width: 73%;
        font-size: @font14;
        color: #303133;
      }
      span {
        color: @color767676;
        float: right;
        margin-top: 2px;
      }
    }
  }
  .page-list {
    margin-top: 5%;
    padding: 0 3%;
    cursor: pointer;
    p {
      font-size: @font14;
      height: 42px;
      line-height: 20px;
      color: #303133;
      position: relative;
      &:hover {
        .hoverTxtColor();
      }
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 6px;
        display: inline-block;
        width: 10px;
        height: 10px;
        border: 1px solid #ccc;
        border-radius: 50%;
      }
    }
  }

  .answer {
    margin-top: 3%;
    padding-left: 20px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      background: url("../../static/images/forum/bg.png") no-repeat center;
      width: 16px;
      height: 16px;
      display: inline-block;
      background-size: cover;
    }
    h3 {
      font-size: @font16;
      color: #333;
      font-weight: bold;
    }
    p {
      font-size: @font14;
      margin: 10px 0px;
      line-height: 24px;
      a {
        color: #2d9bf0;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.four-enterWrap {
  width: 100%;
  font-size: 20px;
  color: #303133;
  font-weight: bold;
  padding: 3%;
  background: url("../../static/images/index/adBg.png") no-repeat center;
  background-size: cover;
  .page-three-enter {
    width: 800px;
  }
  .page-four-enter {
    padding: 1%;
    cursor: pointer;
    text-align: center;
    a {
      display: inline-block;
    }
    &:hover {
      img {
        .shadow(4px);
      }
    }
  }
}
.proWrap {
  margin-top: 2%;
  .page-pro {
    margin: 15px 0px;
    .page-pro-list {
      margin: 15px 0px;
      .page-pro-main {
        display: block;
        text-align: center;
        padding: 15px;
        border: 1px solid #f5f5f5;
        background-color: #f5f9fe;
        font-size: @font14;
        cursor: pointer;
        h3 {
          font-size: @font18;
          font-weight: 400;
          margin-bottom: 3%;
        }
        p {
          color: #333;
          margin-bottom: 3%;
        }
        .area {
          color: #333;
          margin-bottom: 3%;
        }
        .date {
          color: @color767676;
          margin-bottom: 3%;
        }
        .readMore {
          color: @color2d9bf0;
        }
        &:hover {
          .shadow(0px);
        }
      }
    }
  }
}
@media (min-width: 320px) and (max-width: 767px) {
  .slideMenu {
    display: block;
  }
  .four-enterWrap .page-three-enter {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue